import { SimpleGrid } from "@mantine/core";
import { FaUniversity } from "react-icons/fa";
import AccountCard from "../../ui/AccountCard";
import EmptyStateCard from "../../ui/EmptyStateCard";

const BankAccountGrid = ({ accounts = [] }) => {
  if (!accounts.length) {
    return (
      <EmptyStateCard
        icon={<FaUniversity size={48} />}
        title="No Bank Accounts"
        description="You haven't added any bank accounts yet."
      />
    );
  }

  return (
    <div className="p-1">
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xl">
      {accounts.map((bank, idx) => (
        <AccountCard
          key={idx}
          data={bank}
          fields={[
            {
              key: "bankName",
              label: "Bank Name",
              icon: <FaUniversity />,
            },
            {
              key: "accountName",
              label: "Account Name",
            },
            {
              key: "accountNumber",
              label: "Account Number",
            },
          ]}
        />
      ))}
    </SimpleGrid>
    </div>
  );
};

export default BankAccountGrid;
